import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';

const Page: FC = () => {
  const { t } = useTranslation(['common']);
  const title = t('third_party.create_title');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  const tabs = useTabs({
    parentType: Parent_Type_Enum.ThirdParty,
    parent: null,
    hrefRoot: `third-party/add`,
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Title-only toolbar (CUS-169) — flag-gated. The create form keeps its own
      // Create / Cancel buttons; the toolbar has no save/actions here.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.ThirdParty}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
